import React from 'react';
import {
    Card, Select, Tag, Button, Space, Typography, Divider, Alert,
} from 'antd';
import useBundles from './useBundles';
import { FEATURE_GROUPS } from './featureAccess';

const { Text } = Typography;
const { CheckableTag } = Tag;

// gohire-admin editor for the global bundle catalog (bundle → features).
const BundlesPanel = () => {
    const b = useBundles();

    return (
        <div className="gh-dash-grid">
            <Card
                className="gh-dash-card"
                title="Bundles"
                extra={(
                    <Select
                        style={{ minWidth: 240 }}
                        value={b.bundleKey}
                        onChange={b.setBundleKey}
                        options={b.bundles.map((x) => ({ label: x.label, value: x.key }))}
                    />
                )}
            >
                <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 14 }}
                    message="A bundle is a named set of features. Editing it changes access for every user assigned this bundle, across all companies, immediately. GH Admins always have full access and are unaffected."
                />

                <Space style={{ marginBottom: 12 }}>
                    <Text strong>{b.bundles.find((x) => x.key === b.bundleKey)?.label}</Text>
                    {b.customized ? <Tag color="blue">customized</Tag> : <Tag>default</Tag>}
                </Space>

                <div>
                    {Object.entries(FEATURE_GROUPS).map(([group, features]) => (
                        <div key={group} style={{ marginBottom: 12 }}>
                            <Text strong style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '.04em', color: '#8c8c8c', display: 'block', marginBottom: 6 }}>
                                {group}
                            </Text>
                            <Space size={[6, 6]} wrap>
                                {features.map((f) => (
                                    <CheckableTag
                                        key={f.key}
                                        checked={b.selected.includes(f.key)}
                                        onChange={(checked) => b.setSelected((prev) => (
                                            checked ? [...new Set([...prev, f.key])] : prev.filter((k) => k !== f.key)
                                        ))}
                                    >
                                        {f.label}
                                    </CheckableTag>
                                ))}
                            </Space>
                        </div>
                    ))}
                </div>

                {b.isEmpty && (
                    <Alert
                        type="error"
                        showIcon
                        style={{ marginTop: 4, marginBottom: 10 }}
                        message="Select at least one feature. A bundle must grant at least one feature to be saved."
                    />
                )}

                <Divider style={{ margin: '10px 0' }} />
                <Space>
                    <Button type="primary" loading={b.saving} disabled={!b.canSave} onClick={b.save}>Save bundle</Button>
                    <Button disabled={!b.dirty || b.saving} onClick={b.reset}>Reset</Button>
                    <Button type="link" onClick={b.restoreDefault}>Restore default</Button>
                </Space>
            </Card>
        </div>
    );
};

export default BundlesPanel;
